export default __webpack_public_path__ + "static/media/cs.5151901b.md";